<template>
    <div>
        <v-snackbar
            v-model="snackbar"
            :timeout="snackbar_timeout"
            :color="snackbar_color"
            :top="true"
        >
            {{ snackbar_message }}
        </v-snackbar>

        <v-card flat class="mt-5">
            <v-card-title>
                <h6 class="primary--text">Liste des niveaux d'instruction</h6>
                <v-spacer></v-spacer>

                <v-btn
                    rounded
                    color="primary"
                    class="text-capitalize"
                    v-if="$can('create school level')"
                >
                    <export-excel
                        :data="school_levels"
                        name="SchoolLevels.xls"
                        :export-fields="school_levels_fields"
                    >
                        Exporter
                        <v-icon right>mdi-share-outline</v-icon>
                    </export-excel>
                </v-btn>
                <v-spacer></v-spacer>

                <v-dialog v-model="dialog_edit" max-width="500px">
                    <template v-slot:activator="{ on }">
                        <v-btn
                            rounded
                            color="primary"
                            dark
                            class="mb-2"
                            v-on="on"
                            v-if="$can('create school level')"
                        >
                            Ajouter
                            <v-icon right>mdi-plus-circle-outline</v-icon>
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>

                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12 sm12 md12>
                                        <v-text-field
                                            v-model="editedItem.name"
                                            label="Nom du  niveau d'instruction"
                                            solo
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="info"
                                rounded
                                @click="dialog_edit = false"
                                >Fermer</v-btn
                            >
                            <v-btn color="primary" rounded @click="save"
                                >Enregistrer</v-btn
                            >
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-spacer></v-spacer>

                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Rechercher un  niveau d'instruction"
                    single-line
                    solo
                    hide-details
                >
                </v-text-field>
            </v-card-title>
        </v-card>
        <v-data-table
            v-if="school_levels"
            :headers="headers"
            :items="school_levels"
            :loading="loading"
            loading-text="Loading..."
            sort-by="name"
            :search="search"
            class="elevation-1"
        >
            <template v-slot:item.action="{ item }">
                <v-icon
                    small
                    class="mr-2"
                    @click="editItem(item)"
                    v-if="$can('edit school level')"
                >
                    mdi-pencil-outline
                </v-icon>
                <v-icon
                    small
                    @click="deleteItem(item)"
                    v-if="$can('delete school level')"
                >
                    mdi-trash-can-outline
                </v-icon>
            </template>
        </v-data-table>

        <v-layout row justify-center>
            <v-dialog v-model="dialog_deletion" max-width="290">
                <v-card>
                    <v-card-title class="headline">Suppression</v-card-title>
                    <v-card-text class="text-center">
                        Etes-vous sûr de vouloir supprimer ce niveau
                        d'instruction?
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            color="orange"
                            rounded
                            @click="dialog_deletion = false"
                        >
                            <span class="white-couleur">Non</span>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="success"
                            rounded
                            @click="delSchoolLevel()"
                        >
                            Oui
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </div>
</template>

<script>
import Permissions from "~/mixins/Permissions";

export default {
    name: "settings-actor-type",
    mixins: [Permissions],
    data: () => ({
        del_school_level: null,
        del_index: null,
        search: "",
        dialog_edit: false,
        dialog_deletion: false,
        headers: [
            { text: "Niveau d'instruction", value: "name" },
            { text: "Actions", value: "action", sortable: false }
        ],
        school_levels_fields: {
            "Niveau d'instruction": "name"
        },
        snackbar: false,
        snackbar_message: "",
        snackbar_timeout: 5000,
        snackbar_color: "",
        loading: false,
        editedIndex: -1,
        editedItem: {
            name: "",
            country_id: null
        },
        defaultItem: {
            name: "",
            country_id: null
        }
    }),

    created() {
        this.loading = true;
        this.fetchUtils();
        this.loading = false;
    },

    computed: {
        pays() {
            return this.$store.getters.countries;
        },
        school_levels() {
            return this.$store.getters.school_levels;
        },
        formTitle() {
            return this.editedIndex === -1
                ? "Nouveau niveau d'instructions"
                : "Editer niveau d'instruction";
        }
    },

    watch: {
        dialog(val) {
            val || this.close();
        }
    },

    methods: {
        fetchUtils() {
            this.$store.dispatch("fetchCountries");
            this.$store.dispatch("fetchSchoolLevels");
        },

        editItem(item) {
            this.editedIndex = this.school_levels.indexOf(item);
            this.editedItem = Object.assign({}, item);

            this.dialog_edit = true;
        },

        deleteItem(item) {
            this.del_index = this.school_levels.indexOf(item);
            this.dialog_deletion = true;
            this.del_school_level = item;
        },

        close() {
            this.dialog_edit = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },

        async save() {
            if (this.editedIndex > -1) {
                await this.$store.dispatch(
                    "updateSchoolLevel",
                    this.editedItem
                );
                this.snackbar = true;
                this.snackbar_color = "success";
                this.snackbar_message =
                    "Niveau d'instruction édité avec succès !";
            } else {
                await this.$store.dispatch(
                    "createSchoolLevel",
                    this.editedItem
                );
                this.snackbar = true;
                this.snackbar_color = "success";
                this.snackbar_message =
                    "Niveau d'instruction enregistré avec succès !";
            }
            this.close();
        },

        async delSchoolLevel() {
            await this.$store.dispatch(
                "deleteSchoolLevel",
                this.del_school_level
            );
            this.dialog_deletion = false;
            this.snackbar = true;
            this.snackbar_color = "success";
            this.snackbar_message =
                "Niveau d'instruction supprimé avec succès !";
        }
    }
};
</script>

<style scoped>
.white-couleur {
    color: white;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/settings/school-levels/list.vue